module.exports = "/static/media/arrows_icon.e0a5c2d2.svg";